import { trackEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_TYPE } from './globals';

const PERSONAL_INFO_WARNING_MODAL = 'personal_contact_details_warning_modal';
const EVENT_TEMPLATE_ID = '171';

// https://dataportal.zillowgroup.net/event-registry/8881
export const emitOpenPersonalInfoWarningModalEvent = () =>
  trackEvent({
    envelope: {
      event_type_id: '8881',
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Impression,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: PERSONAL_INFO_WARNING_MODAL,
      trigger_object_nm: 'reply_with_personal_info',
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewContent,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
  });

// https://dataportal.zillowgroup.net/event-registry/8882
export const emitSendAnywayInPersonalInfoWarningModalEvent = () =>
  trackEvent({
    envelope: {
      event_type_id: '8882',
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'send_anyway_button',
      trigger_object_nm: PERSONAL_INFO_WARNING_MODAL,
    },
    semantic: {
      semantic_event_nm: 'personal_info_warning',
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
  });
